(function(){
  const IN_TO_MM=25.4;
  const state={};
  const money=n=>'$'+Number(n||0).toFixed(2);
  const num=(v,d=0)=>{const n=parseFloat(v);return Number.isFinite(n)?n:d};
  const fmt=n=>Number(n||0).toFixed(3).replace(/0+$/,'').replace(/\.$/,'');
  const uid=()=> 'RF-'+new Date().toISOString().slice(0,10).replaceAll('-','')+'-'+Math.floor(Math.random()*9000+1000);

  function readConfig(root){
    return {
      logoUrl:root.dataset.logoUrl||'https://cdn.shopify.com/s/files/1/0401/2867/5885/files/Black_Flat_10.png?v=1748102193',
      setupFee:num(root.dataset.setupFee,50),
      fallbackMoldPrice:num(root.dataset.retailMoldPrice,42),
      priceTiers:[
        { max:num(root.dataset.tier1Max,200), price:num(root.dataset.tier1Price,32) },
        { max:num(root.dataset.tier2Max,350), price:num(root.dataset.tier2Price,38) },
        { max:num(root.dataset.tier3Max,500), price:num(root.dataset.tier3Price,42) },
        { max:num(root.dataset.tier4Max,700), price:num(root.dataset.tier4Price,48) },
        { max:num(root.dataset.tier5Max,900), price:num(root.dataset.tier5Price,54) },
        { max:num(root.dataset.tier6Max,1200), price:num(root.dataset.tier6Price,62) },
        { max:Infinity, price:num(root.dataset.tierOverPrice,70) }
      ].filter(t=>Number.isFinite(t.price)),
      minimumOrder:Math.max(1,Math.round(num(root.dataset.minimumOrder,5))),
      printedSampleFee:num(root.dataset.printedSampleFee,25),
      clearanceMM:num(root.dataset.clearanceMm,2),
      wallMM:num(root.dataset.wallMm,5)
    };
  }

  function getInputs(root){
    const g=k=>root.querySelector(`[data-refill-input="${k}"]`);
    return {
      jarBrand:g('jarBrand')?.value?.trim()||'',
      jarName:g('jarName')?.value?.trim()||'',
      topDiameter:num(g('topDiameter')?.value,0),
      bottomDiameter:num(g('bottomDiameter')?.value,0),
      insideHeight:num(g('insideHeight')?.value,0),
      fillHeight:num(g('fillHeight')?.value,0),
      bottomFilletMM:num(g('bottomFilletMM')?.value,0)
    };
  }

  function calc(inputs,config){
    const clearanceIn=config.clearanceMM/IN_TO_MM;
    const refillTop=Math.max(inputs.topDiameter-clearanceIn,0);
    const refillBottom=Math.max(inputs.bottomDiameter-clearanceIn,0);
    const refillHeight=Math.max(Math.min(inputs.fillHeight||inputs.insideHeight,inputs.insideHeight),0);
    const sideAngleRad=Math.atan(((inputs.topDiameter-inputs.bottomDiameter)/2)/Math.max(inputs.insideHeight,.0001));
    const sideAngleDeg=sideAngleRad*180/Math.PI;

    // Internal only, intentionally not displayed publicly.
    const wallIn=config.wallMM/IN_TO_MM;
    const innerVol=frustumVolume(refillTop/2,refillBottom/2,refillHeight);
    const outerVol=frustumVolume(refillTop/2+wallIn,refillBottom/2+wallIn,refillHeight+wallIn);
    const siliconeMl=Math.max((outerVol-innerVol)*16.387064,0);

    const moldPrice=getTierMoldPrice(siliconeMl,config);
    const base=config.setupFee+(config.minimumOrder*moldPrice);
    return {clearanceIn,refillTop,refillBottom,refillHeight,sideAngleDeg,siliconeMl,moldPrice,baseEstimate:base};
  }

  function frustumVolume(r1,r2,h){return Math.PI*h*(r1*r1+r1*r2+r2*r2)/3;}

  function getTierMoldPrice(siliconeMl,config){
    const tiers=(config.priceTiers||[]).slice().sort((a,b)=>a.max-b.max);
    const match=tiers.find(t=>siliconeMl<=t.max);
    return match ? match.price : config.fallbackMoldPrice;
  }

  function buildSvg(inputs,c,config,forDownload=false){
    const W=850,H=1100;
    const title=`Refill Fit Drawing`;
    const maxDrawH=520,maxDrawW=360;
    const scale=Math.min(maxDrawH/Math.max(inputs.insideHeight,.01), maxDrawW/Math.max(inputs.topDiameter,.01));
    const cx=425, baseY=770, topY=baseY-inputs.insideHeight*scale;
    const topW=inputs.topDiameter*scale, bottomW=inputs.bottomDiameter*scale;
    const refillTopW=c.refillTop*scale, refillBottomW=c.refillBottom*scale, refillH=c.refillHeight*scale;
    const filletPx=Math.min(inputs.bottomFilletMM/IN_TO_MM*scale, Math.min(bottomW*.18, 55));
    const bottomY=baseY;
    const fillY=baseY-refillH;
    const jarPath=filletPx>0
      ? `M ${cx-topW/2} ${topY} L ${cx-bottomW/2} ${bottomY-filletPx} Q ${cx-bottomW/2} ${bottomY} ${cx-bottomW/2+filletPx} ${bottomY} L ${cx+bottomW/2-filletPx} ${bottomY} Q ${cx+bottomW/2} ${bottomY} ${cx+bottomW/2} ${bottomY-filletPx} L ${cx+topW/2} ${topY}`
      : `M ${cx-topW/2} ${topY} L ${cx-bottomW/2} ${bottomY} L ${cx+bottomW/2} ${bottomY} L ${cx+topW/2} ${topY}`;
    const refillPath=`M ${cx-refillTopW/2} ${fillY} L ${cx-refillBottomW/2} ${baseY} L ${cx+refillBottomW/2} ${baseY} L ${cx+refillTopW/2} ${fillY} Z`;
    const logo=config.logoUrl?`<image href="${escapeXml(config.logoUrl)}" x="620" y="42" width="170" height="70" preserveAspectRatio="xMidYMid meet"/>`:'';
    return `<svg xmlns="http://www.w3.org/2000/svg" width="8.5in" height="11in" viewBox="0 0 ${W} ${H}">
      <rect width="${W}" height="${H}" fill="#fff"/>
      ${logo}
      <text x="60" y="65" font-family="Arial" font-size="22" font-weight="700">Modern Craft Labs</text>
      <text x="60" y="94" font-family="Arial" font-size="16">${title}</text>
      <text x="60" y="122" font-family="Arial" font-size="11" fill="#555">Print at 100% / Actual Size. Verify scale with the 1 inch square.</text>
      <line x1="50" y1="150" x2="800" y2="150" stroke="#111"/>
      <text x="60" y="184" font-family="Arial" font-size="13">Jar Brand: ${escapeXml(inputs.jarBrand||'')}</text>
      <text x="60" y="207" font-family="Arial" font-size="13">Jar Name: ${escapeXml(inputs.jarName||'')}</text>
      <text x="60" y="230" font-family="Arial" font-size="13">Generated: ${new Date().toLocaleDateString()}</text>
      <text x="60" y="253" font-family="Arial" font-size="13">Drawing: ${uid()}</text>
      <path d="${jarPath}" fill="none" stroke="#111" stroke-width="3"/>
      <path d="${refillPath}" fill="rgba(0,0,0,.10)" stroke="#245" stroke-width="2"/>
      <line x1="${cx-refillTopW/2-35}" y1="${fillY}" x2="${cx+refillTopW/2+35}" y2="${fillY}" stroke="#111" stroke-width="1.5" stroke-dasharray="7 6"/>
      <text x="${cx+refillTopW/2+45}" y="${fillY+4}" font-family="Arial" font-size="12">Fill Height ${fmt(inputs.fillHeight)}&quot;</text>
      <line x1="${cx-topW/2}" y1="${topY-28}" x2="${cx+topW/2}" y2="${topY-28}" stroke="#111"/>
      <text x="${cx}" y="${topY-38}" text-anchor="middle" font-family="Arial" font-size="12">Inner Top ${fmt(inputs.topDiameter)}&quot;</text>
      <line x1="${cx-bottomW/2}" y1="${baseY+42}" x2="${cx+bottomW/2}" y2="${baseY+42}" stroke="#111"/>
      <text x="${cx}" y="${baseY+64}" text-anchor="middle" font-family="Arial" font-size="12">Inner Bottom ${fmt(inputs.bottomDiameter)}&quot;</text>
      <line x1="${cx+Math.max(topW,bottomW)/2+60}" y1="${topY}" x2="${cx+Math.max(topW,bottomW)/2+60}" y2="${baseY}" stroke="#111"/>
      <text x="${cx+Math.max(topW,bottomW)/2+74}" y="${topY+(baseY-topY)/2}" font-family="Arial" font-size="12">Height ${fmt(inputs.insideHeight)}&quot;</text>
      <rect x="60" y="840" width="96" height="96" fill="none" stroke="#111" stroke-width="2"/>
      <text x="60" y="955" font-family="Arial" font-size="12">1&quot; Scale Check</text>
      <rect x="255" y="845" width="540" height="135" fill="#fafafa" stroke="#ddd"/>
      <text x="280" y="875" font-family="Arial" font-size="15" font-weight="700">Suggested Refill Size</text>
      <text x="280" y="905" font-family="Arial" font-size="13">Top Diameter: ${fmt(c.refillTop)}&quot;</text>
      <text x="280" y="928" font-family="Arial" font-size="13">Bottom Diameter: ${fmt(c.refillBottom)}&quot;</text>
      <text x="280" y="951" font-family="Arial" font-size="13">Height: ${fmt(c.refillHeight)}&quot;</text>
      <text x="520" y="905" font-family="Arial" font-size="13">Bottom Fillet: ${fmt(inputs.bottomFilletMM)} mm</text>
      <text x="520" y="928" font-family="Arial" font-size="13">Estimated Side Angle: ${fmt(c.sideAngleDeg)}°</text>
      <text x="60" y="1030" font-family="Arial" font-size="11" fill="#555">This drawing is a fit preview based on customer-provided measurements. Final sizing is confirmed after review.</text>
    </svg>`;
  }

  function render(root){
    const config=readConfig(root), inputs=getInputs(root), c=calc(inputs,config), svg=buildSvg(inputs,c,config,false);
    root.querySelector('[data-refill-svg]').outerHTML=svg.replace('<svg','<svg data-refill-svg role="img" aria-label="Refill fit drawing"');
    const results=root.querySelector('[data-refill-results]');
    results.innerHTML=`<div class="mcl-result-card"><strong>Suggested Refill Size</strong>Top: ${fmt(c.refillTop)}&quot;<br>Bottom: ${fmt(c.refillBottom)}&quot;<br>Height: ${fmt(c.refillHeight)}&quot;</div><div class="mcl-result-card"><strong>Shape Notes</strong>Bottom Fillet: ${fmt(inputs.bottomFilletMM)} mm<br>Estimated Side Angle: ${fmt(c.sideAngleDeg)}°</div>`;
    state.config=config;state.inputs=inputs;state.calc=c;state.svg=buildSvg(inputs,c,config,true);
    document.dispatchEvent(new CustomEvent('mcl:refill:update',{detail:getPublicState()}));
  }

  function getPublicState(sample=false){
    const quantity=state.config?.minimumOrder||5;
    const sampleFee=sample?state.config.printedSampleFee:0;
    const moldPrice=state.calc?.moldPrice ?? state.config?.fallbackMoldPrice ?? 42;
    const total=(state.config?.setupFee||50)+(quantity*moldPrice)+sampleFee;
    return {inputs:state.inputs,calc:state.calc,config:state.config,svg:state.svg,quantity,moldPrice,sampleFee,total};
  }

  function downloadSvg(){
    const blob=new Blob([state.svg],{type:'image/svg+xml'});
    const a=document.createElement('a');
    a.href=URL.createObjectURL(blob);
    a.download='refill-fit-drawing.svg';
    a.click();
    URL.revokeObjectURL(a.href);
  }

  function escapeXml(s){return String(s||'').replace(/[&<>"]/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]));}

  document.addEventListener('DOMContentLoaded',()=>{
    const calcRoot=document.querySelector('[data-refill-calculator]');
    if(calcRoot){
      calcRoot.querySelectorAll('[data-refill-input]').forEach(el=>el.addEventListener('input',()=>render(calcRoot)));
      calcRoot.querySelector('[data-download-svg]')?.addEventListener('click',downloadSvg);
      render(calcRoot);
    }
    const contact=document.querySelector('[data-refill-contact]');
    if(contact){
      const toggle=contact.querySelector('[data-printed-sample-toggle]');
      function updateContact(){
        const detail=getPublicState(toggle?.checked);
        const cfg=detail.config||{};
        const price=`Setup Fee: ${money(cfg.setupFee)}\nMinimum Molds: ${detail.quantity}\nMold Price: ${money(detail.moldPrice)} each\nPrinted Fit Sample: ${toggle?.checked?'Yes '+money(cfg.printedSampleFee):'No'}\nEstimated Total: ${money(detail.total)}`;
        const summary=`Jar Brand: ${detail.inputs?.jarBrand||''}\nJar Name: ${detail.inputs?.jarName||''}\nInner Top: ${fmt(detail.inputs?.topDiameter)} in\nInner Bottom: ${fmt(detail.inputs?.bottomDiameter)} in\nInside Height: ${fmt(detail.inputs?.insideHeight)} in\nFill Height: ${fmt(detail.inputs?.fillHeight)} in\nBottom Fillet: ${fmt(detail.inputs?.bottomFilletMM)} mm\nSuggested Refill Top: ${fmt(detail.calc?.refillTop)} in\nSuggested Refill Bottom: ${fmt(detail.calc?.refillBottom)} in\nSuggested Refill Height: ${fmt(detail.calc?.refillHeight)} in\nEstimated Side Angle: ${fmt(detail.calc?.sideAngleDeg)} degrees`;
        contact.querySelector('[data-refill-price-summary]').innerHTML=`<div class="mcl-price-line"><span>Setup Fee</span><span>${money(cfg.setupFee)}</span></div><div class="mcl-price-line"><span>${detail.quantity} Molds @ ${money(detail.moldPrice)}</span><span>${money(detail.quantity*detail.moldPrice)}</span></div>${toggle?.checked?`<div class="mcl-price-line"><span>Printed Fit Sample</span><span>${money(cfg.printedSampleFee)}</span></div>`:''}<div class="mcl-price-line"><span>Estimated Total</span><span>${money(detail.total)}</span></div>`;
        contact.querySelector('[data-contact-summary]').value=summary;
        contact.querySelector('[data-contact-pricing]').value=price;
        contact.querySelector('[data-contact-svg]').value=detail.svg||'';
        contact.querySelector('[data-contact-sample]').value=toggle?.checked?'Yes':'No';
      }
      toggle?.addEventListener('change',updateContact);
      document.addEventListener('mcl:refill:update',updateContact);
      updateContact();
    }
  });
})();